<template>
  <div class="block">
    <div class="container">
      <!--  -->
      <div class="title title-cust">荣誉证书</div>
      <div class="entitle entitle-cust">Certificate of honor</div>

      <div v-if="isMobile">
        <div class="row">
          <div class="col-xs-6" v-for="item in rows_mb" :key="item.key">
            <div class="item">
              <img
                :src="item.img"
                class="img-responsive hvr-bounce-in"
                alt=""
              />
              <div class="item-text">{{ item.text }}</div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-xs-4" v-for="item in rows_mb2" :key="item.key">
            <div class="item">
              <img
                :src="item.img"
                class="img-responsive hvr-bounce-in"
                alt=""
              />
              <div class="item-text">{{ item.text }}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="row" v-else>
        <div class="col-percent-20" v-for="item in rows" :key="item.key">
          <div class="item">
            <img :src="item.img" class="img-responsive hvr-bounce-in" alt="" />
            <div class="item-text">{{ item.text }}</div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-xs-4 col-sm-2" v-for="item in rows2" :key="item.key">
          <div class="item">
            <img :src="item.img" class="img-responsive hvr-bounce-in" alt="" />
            <div class="item-text">{{ item.text }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import p5 from "@/assets/images/about/p5.png";
import p6 from "@/assets/images/about/p6.png";
import p7 from "@/assets/images/about/p7.png";
import p8 from "@/assets/images/about/p8.png";
import p9 from "@/assets/images/about/p9.png";

import p10 from "@/assets/images/about/p10.png";
import p11 from "@/assets/images/about/p11.png";
import p12 from "@/assets/images/about/p12.png";
import p13 from "@/assets/images/about/p13.png";
import p14 from "@/assets/images/about/p14.png";
import p15 from "@/assets/images/about/p15.png";

const rows = [
  { key: 1, img: p5, text: "高新技术企业" },
  { key: 2, img: p6, text: "CMMI3开发能力" },
  { key: 3, img: p7, text: "双软企业" },
  { key: 4, img: p8, text: "系统建设和服务能力" },
  { key: 5, img: p9, text: "重合同守信用企业" },
];

const rows2 = [
  { key: 1, img: p10, text: "知识产权管理认证" },
  { key: 2, img: p11, text: "质量体系ISO9001" },
  { key: 3, img: p12, text: "信息安全ISO27001" },
  { key: 4, img: p13, text: "服务体系ISO20000" },
  { key: 5, img: p14, text: "质量服务诚信单位" },
  { key: 6, img: p15, text: "ULTIMUS研发中心授权" },
];

export default {
  data() {
    return {
      rows,
      rows2,
    };
  },
  computed: {
    rows_mb() {
      let arr = this.rows || [];
      return arr.slice(0, 2);
    },
    rows_mb2() {
      let arr = this.rows || [];
      return arr.slice(2, 5);
    },
  },
};
</script>

<style scoped>
.title-cust {
  color: #2f56ce;
}
.entitle-cust {
  color: #b3b3b3;
  margin-bottom: 30px;
}
.wrap1 {
  display: flex;
  justify-content: space-between;
}
.item {
  margin-bottom: 20px;
}
.item-text {
  text-align: center;
  padding: 20px 0;
  color: #000;
  font-weight: 600;
}
/* 扩展栅格 */
.col-percent-20 {
  position: relative;
  min-height: 1px;
  padding-right: 15px;
  padding-left: 15px;
  float: left;
  width: 20%;
}

/*  */
.mb .col-percent-20 {
  width: 50%;
}
</style>